import { themeColor, ThemeType } from "@/assets/data/theme"

export function toggleTheme (type: ThemeType) {
  const colors = themeColor[type]
  const root = document.documentElement
  for (const [k, v] of Object.entries(colors)) {
    root.style.setProperty('--' + k, v)
  }
}
